import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Universe from "./pages/Universe";
import Charts from "./pages/Charts";
import AIInsights from "./pages/AIInsights";
import TimeMachine from "./pages/TimeMachine";
import Positions from "./pages/Positions";
import Orders from "./pages/Orders";
import Trades from "./pages/Trades";
import Strategies from "./pages/Strategies";
import Backtests from "./pages/Backtests";
import Compare from "./pages/Compare";
import Alerts from "./pages/Alerts";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import { useAuth } from "./hooks/useAuth";

function App() {
  const { token } = useAuth();

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/universe" element={<Universe />} />
        <Route path="/charts" element={<Charts />} />
        <Route path="/charts/:symbol" element={<Charts />} />
        <Route path="/ai-insights" element={<AIInsights />} />
        <Route path="/timemachine" element={<TimeMachine />} />
        <Route path="/positions" element={<Positions />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/trades" element={<Trades />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/backtests" element={<Backtests />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
